import Vue from "vue";
import Vuex from "vuex";
import staticModule from "./static";
import supplier from "./supplier";
import customer from "./customer";
import product from "./product";
import auth from "./auth";
import user from "./user";
import team from "./team";
import country from "./country";
import order from "./order";
import surgery from "./surgery";
import stripe from "./stripe";
import invite from "./invite";
import category from "./category";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    static: staticModule,
    auth,
    supplier,
    customer,
    product,
    user,
    team,
    country,
    order,
    surgery,
    stripe,
    invite,
    category
  }
});
export default store;
